import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

import { DeviceCard, DevicesTools } from 'Containers/main_layout';

class Devices extends React.Component {

  constructor(props) {
    super(props);
    this.keyComponent = 0
    this.state = {
      searchedDeviceName: '',
      activeFilter: 'all'
    }

  }

  componentWillMount() {
    if (this.props.isThemeDark()) {
      require('Css/devices_dark.css');
    } else {
      require('Css/devices.css');
    }
  }

  componentDidMount() {
    this.props.setSidebarVoice("dispositivi");
    this.props.initStompClient();
  }

  componentWillUnmount(){
    this.props.disconnectFromDevicesSocket();
  }

  onOpenControlPoint(serialNumber, deviceName) {
    this.props.setShowModaleConferma({
      header: "Apertura remota",
      body: <>Aprire in modo remoto il dispositivo <strong>{deviceName}</strong>?</>,
      esegui: () => {
        this.props.openControlPoint(serialNumber);
        this.props.setShowModaleConferma(null);
      }
    });
  }

  onNuovoUtente() {
    this.props.setUserToEdit(null);

    let config = require('../../../../config/config.json');
    const context = `/${config.context}`
    location.href = context + "/nuovo_ospite";
  }

  setSearchedDeviceName(searchedDeviceName) {
    this.setState({
      searchedDeviceName: searchedDeviceName
    })
  }

  setActiveFilter(activeFilter) {
    this.setState({
      activeFilter: activeFilter
    })
  }

  isDeviceOnline(device) {
    if (!device) return false;

    if (device.version >= 5 && device.lastRefresh) {
      const last = new Date(device.lastRefresh);
      const now = new Date();
      const diffMinutes = (now - last) / 1000 / 60;
      return diffMinutes < 5;
    }

    return !!device.online;
  }

  isSharedWithMe(device) {
    if (!device) return false;

    if (device.ownershipType && String(device.ownershipType).toUpperCase() === 'HOST') {
      return true;
    }

    if (device.host === true) {
      return true;
    }

    if (device.owner === true || (device.ownershipType && String(device.ownershipType).toUpperCase() === 'OWNER')) {
      return false;
    }

    const currentUserEmail = this.props.getUser && this.props.getUser() ? this.props.getUser().email : null;
    const ownerEmail = device.ownerUserEmail || device.ownerEmail || device.emailOwner;

    if (currentUserEmail && ownerEmail && typeof ownerEmail === 'string' && ownerEmail.toLowerCase() !== currentUserEmail.toLowerCase()) {
      return true;
    }

    return !!(device.sharedWithMe || device.shared || device.received || device.condivisoConMe);
  }

  isMine(device) {
    if (!device) return false;

    if (device.ownershipType && String(device.ownershipType).toUpperCase() === 'OWNER') {
      return true;
    }

    if (device.owner === true) {
      return true;
    }

    return !this.isSharedWithMe(device);
  }

  getFilteredDevices() {
    const searchedDeviceName = (this.state.searchedDeviceName || '').trim().toLowerCase();
    const devices = this.props.devices && this.props.devices.length > 0 ? this.props.devices : [];

    return devices.filter((device) => {
      const deviceName = device && device.name ? device.name.toLowerCase() : '';

      if (searchedDeviceName !== '' && deviceName.indexOf(searchedDeviceName) === -1) {
        return false;
      }

      switch (this.state.activeFilter) {
        case 'online':
          return this.isDeviceOnline(device);
        case 'offline':
          return !this.isDeviceOnline(device);
        case 'mine':
          return this.isMine(device);
        case 'shared':
          return this.isSharedWithMe(device);
        default:
          return true;
      }
    });
  }

  getFilterCounts() {
    const devices = this.props.devices && this.props.devices.length > 0 ? this.props.devices : [];

    return {
      all: devices.length,
      online: devices.filter((device) => this.isDeviceOnline(device)).length,
      offline: devices.filter((device) => !this.isDeviceOnline(device)).length,
      mine: devices.filter((device) => this.isMine(device)).length,
      shared: devices.filter((device) => this.isSharedWithMe(device)).length
    };
  }

  render() {
    const filteredDevices = this.getFilteredDevices();
    const needsBottomSafeSpace = filteredDevices.length > 4;
    const devicesHtml = filteredDevices.map((device) => {
      return (
        <DeviceCard key={device.id || device.serialNumber || device.name} device={device} />
      )
    });

    return (
      <div className={"devices-page " + (needsBottomSafeSpace ? "devices-page--scroll-safe" : "devices-page--compact")}>
        <DevicesTools
          activeFilter={this.state.activeFilter}
          filterCounts={this.getFilterCounts()}
          setActiveFilter={(activeFilter) => this.setActiveFilter(activeFilter)}
          setSearchedDeviceName={(deviceName) => this.setSearchedDeviceName(deviceName)} />

        {
          this.props.devicesLoading ?
            <div className="devices-loading row mt-4 text-center">
              <div className="col-5">
                <CircularProgress />
              </div>
            </div>
            :
            <div className={"dmd-table-content " + (needsBottomSafeSpace ? "devices-list-scroll-safe" : "devices-list-scroll-compact")}>
              {devicesHtml && devicesHtml.length !== 0 ?
                <>
                  {devicesHtml}
                </>
                :
                <div className="devices-empty-state">{this.props.getLocale().DEVICES_NO_FOUND}</div>
              }
            </div>
        }
      </div>
    )
  }
}

export default Devices
export { Devices }
